import { MapServiceApi } from "../../../impl/layers/server/ArcGIS_APIResponse";
import { GetToken } from "../../misc/authentication/Authentication";
import { Maybe, None, Some } from "../../misc/option";
import { EPSG } from "../../projection";
import { LayerUIFactory } from "../../ui/layer";
export class ServerLayer {
    constructor(opts) {
        this.projection = EPSG(3857);
        this.loaded = false;
        this.is_base = false;
        this.raw = None.instance();
        this.name = "baseserverlayer";
        this.ui = None.instance();
        this.api = None.instance();
        this.token = '';
        this.parsing_failed = false;
        this.layer_id = '';
        this.observers = [];
        if (!this.validate(opts)) {
            console.error("ServerLayer initialized with invalid parameters.");
            return;
        }
        this.opts = opts;
        this.parse_config(opts).then(() => this.on_create());
        this.layer_id = crypto.randomUUID();
    }
    get source() { return this.raw.map((a) => a.getSource()); }
    get visible() { return this.raw.map(a => a.getVisible()).unwrapOr(false); }
    set visible(v) {
        this.notify_visibility_observers(v, this);
        this.raw
            .map(l => l.setVisible(v))
            .map(() => $(`#${this.layer_id}`).prop('checked', v));
    }
    get opacity() { return this.raw.map(a => a.getOpacity()).unwrapOr(0); }
    set opacity(v) {
        this.raw.map(l => l.setOpacity(v));
    }
    changed() {
        this.raw.map(a => a.changed());
    }
    on_create() {
        this.create_ui();
    }
    create_ui() {
        if (this.loaded)
            return;
        this.ui = Maybe(LayerUIFactory.construct_ui_for(this));
        this.loaded = true;
    }
    async make_get_request(url = "", params = { f: 'json' }) {
        var _a, _b;
        let fillUrl = new URL(url.slice(0, 4) === 'http' ? url : 'https:' + url);
        Object.keys(params).forEach(key => fillUrl.searchParams.append(key, params[key]));
        if ((_a = this.opts) === null || _a === void 0 ? void 0 : _a.authRequired) {
            var tokenResponse = await GetToken({
                name: this.opts.name,
                serviceUrl: this.opts.exportUrl,
                authUser: this.opts.authUser,
                authPassword: this.opts.authPassword
            });
            this.token = tokenResponse.token;
            if (this.token) {
                fillUrl.searchParams.append('token', this.token);
            }
            else {
                console.error((_b = tokenResponse.error) === null || _b === void 0 ? void 0 : _b.details);
            }
        }
        const response = await fetch(fillUrl.toString(), {
            method: "GET",
            mode: 'cors',
            cache: 'default',
            redirect: 'follow'
        });
        return response;
    }
    async get_service_api(urls = [""]) {
        if (this.api.isNone()) {
            try {
                const response = await this.make_get_request(urls[0]);
                let info = await response.json();
                if ('error' in info) {
                    throw info.error.message;
                }
                const api = new MapServiceApi(urls, info, this.token);
                this.api = new Some(api);
                return api;
            }
            catch (err) {
                console.error(`fetch error: ${err}. Url: ${urls[0]}`);
                return null;
            }
        }
        return this.api.unwrap();
    }
    async get_query_service_extent(url) {
        const params = {
            f: "json",
            where: "1=1",
            returnExtentOnly: true,
        };
        const response = await this.make_get_request(url, params)
            .then(res => res.json())
            .then(data => data.extent)
            .catch(err => { console.error(`error fetching parcel query api extent: ${err}. Url: ${url}`); return null; });
        return response;
    }
    async get_vector_layer_info(url = "") {
        let info = await this.make_get_request(url).then(res => res.json())
            .catch(err => console.error(`fetch error: ${err}. Url: ${url}`));
        if (info) {
            const drawingInfo = info.drawingInfo;
            if (this.token) {
                drawingInfo.token = this.token;
            }
            return drawingInfo;
        }
        return null;
    }
    add_visibilty_observer(observer) {
        this.observers.push(observer);
    }
    remove_visibilty_observer(observer) {
        this.observers = this.observers.filter(obs => obs !== observer);
    }
    notify_visibility_observers(value, layer) {
        if (this.observers.length) {
            this.observers.forEach(observer => observer(value, layer));
        }
    }
    display_loading_indicator(flag) {
        const loader = $(`[data-loader-ref="${this.layer_id}"]`);
        if (loader.length) {
            flag ? loader.removeClass('hidden') : loader.addClass('hidden');
        }
    }
}
